import React from "react";
import { AddIcon } from "../../Icons";

const CardButton = ({ title, subtitle }) => {
  return (
    <div className="add-new-card-button-wrapper">
      <div className="add-new-card-icon">
        <AddIcon />
      </div>
      <div className="pl-3">
        <h3 className="add-new-card-title">
          {title}
        </h3>
        <p className="add-new-card-subtitle">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default CardButton;
